import {BaseModel} from "./base-model";

export class BaseRemoteConfigModel extends BaseModel {
  dateExpirationDaysDiff: Number;

  constructor(model) {
    super();

    this.dateExpirationDaysDiff = model?.dateExpirationDaysDiff;
  }

  populate(model) {
    this.dateExpirationDaysDiff = model?.dateExpirationDaysDiff;
  }
}
